import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { first, Observable } from 'rxjs';

import { selectIsInIntegratedMode } from 'src/app/store/common/common.selectors';

import { NbaConditionResolver } from '../nba-condition-resolver.interface';

import { NbaConditionResolverId } from './nba-condition-resolver-id.enum';

@Injectable()
export class IsInIntegratedModeResolver implements NbaConditionResolver {
  public readonly identifier: string = NbaConditionResolverId.IsInIntegratedMode;

  public constructor(private readonly store: Store) {}

  /**
   * @returns (observable of) true if running in integrated mode (aka seamless), false otherwise
   */
  public resolve$(): Observable<boolean> {
    return this.store.select(selectIsInIntegratedMode).pipe(first());
  }
}
